import { useMemo, useState } from 'react';
import TopMenu from 'components/Reservation/TopMenu';
import useCustomers from 'graphql/useCustomers';
import List from 'components/common/ListWithMoreOptions';
import { useTranslation } from 'react-i18next';
import s from './styles';

const SCAPE_VALUE = '\\';

function fixValueForQuery(value) {
  return value
    .replace(`${SCAPE_VALUE}`, `${SCAPE_VALUE}${SCAPE_VALUE}`)
    .replace('*', `${SCAPE_VALUE}*`);
}

function Reservations() {
  const { t } = useTranslation();

  // const [confirmDeleteModal, setConfirmDeleteModal] = useState(false);
  // const [customerDelete, setCustomerDelete] = useState('');
  const [sorting, setSorting] = useState({ columnId: 'name', order: 1 });
  const [filter] = useState('all');
  const [search] = useState('');
  const [pagination] = useState({ itemsPerPage: 10, page: 0 });
  const [profileViewList] = useState('list');

  const { customers: customer = [] } = useCustomers();

  const { customersList } = useMemo(() => {
    const customersListFilteredProfile = customer;

    let customersListFiltered = customersListFilteredProfile.filter((i) => {
      const regex = new RegExp(fixValueForQuery(search), 'i');
      return (
        (i.name && i.name.match(regex)) ||
        (i.lastName && i.lastName.match(regex)) ||
        (i.name && i.lastName && `${i.name} ${i.lastName}`.match(regex)) ||
        (i.address1 && i.address1.match(regex)) ||
        (i.idNumber && i.address1.match(regex)) ||
        i.ref?.toLocaleLowerCase().includes(search)
      );
    });

    customersListFiltered = customersListFiltered.sort((a, b) => {
      if (a[sorting.columnId] < b[sorting.columnId]) return -1 * sorting.order;
      if (a[sorting.columnId] > b[sorting.columnId]) return 1 * sorting.order;
      return 0;
    });

    let customersList = customersListFiltered.slice(
      pagination.page * pagination.itemsPerPage,
      (pagination.page + 1) * pagination.itemsPerPage
    );

    customersList = customersList.map((item) => ({
      element: item,
      id: item._id,
      columns: ['02:00 pm', 'Ivan', 5, 'Lorena Ramirez', '#5', 'Sentados'],
    }));

    return {
      customersList,
      customersListFiltered,
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customer, pagination, filter, search, profileViewList, sorting]);

  return (
    <s.PageContainer>
      <TopMenu />

      <List
        handleEdit={() => {}}
        handleDeleteWorker={() => [
          // setConfirmDeleteModal(true),
          // setCustomerDelete(customer),
        ]}
        workers={customersList}
        columns={[
          {
            title: t('containers.Reservations.hour'),
            sortable: true,
            columnId: 'name',
          },
          {
            title: t('containers.Reservations.reservationName'),
            sortable: true,
            columnId: 'nif',
          },
          {
            title: t('containers.Reservations.Ndiners'),
            sortable: true,
            columnId: 'ref',
          },
          {
            title: t('containers.Reservations.AnotationBy'),
            sortable: true,
            columnId: 'email',
          },
          {
            title: t('containers.Reservations.nReservations'),
            sortable: true,
            columnId: 'email',
          },
          {
            title: t('containers.Reservations.condition'),
            sortable: true,
            columnId: 'address1',
          },
          {
            title: '',
          },
        ]}
        sorting={sorting}
        changeSorting={(columnId, order) => setSorting({ columnId, order })}
        tableStyle={{ gridTemplateColumns: '6fr 10fr 9fr 9fr 9fr  10fr 3fr' }}
      />
    </s.PageContainer>
  );
}

export default Reservations;
